/* eslint-disable @typescript-eslint/quotes */
import { Injectable } from '@angular/core';
//import FormData from 'form-data';
//import {FormData} from '@angular/forms';
import { Observable, of } from 'rxjs';
import { EnvironmentService } from '../../../environments/environment.service';
import { CallService } from '../call-service/browser/call.service';
import { HealthCheck, LoginType, ServerAuthData, Token } from './auth.models';

@Injectable({
	providedIn: 'root'
})
export class AuthService {
	private loginUrl = this.environment.loginUrl;
	private softLoginUrl = this.environment.softLoginUrl;

	private renewTokenUrl = this.environment.renewTokenUrl;
	private logoutUrl = this.environment.logoutUrl;

	constructor(private environment: EnvironmentService, private callService: CallService) { }

	login(
		email: string,
		password: string,
		rememberMe: boolean,
		loginType: LoginType
	): Observable<ServerAuthData> {
		const formData = {
			email: email,
			password: password,
			rememberme: rememberMe,
			logintype: loginType,
		};

		//  this.logService.info('auth-service, calling login:',true,true,this.loginUrl);
		const result = this.callService.CallAuth<ServerAuthData>(
			'POST',
			this.loginUrl,
			undefined,
			formData
		);
		return result;
	}

	softLogin(softToken: string): Observable<ServerAuthData> {
		const formData: any = new FormData();


		const result = this.callService.CallAuth<ServerAuthData>(
			'POST',
			this.softLoginUrl,
			softToken,
			formData
		);
		return result;
	}

	renewToken(renewToken?: Token): Observable<ServerAuthData> {
		// new-login (2.9/2.10): renew alla cieca (solo cookie HttpOnly). In migrazione,
		// se un DOTTNET-RENEW legacy da localStorage è passato, va nel body come
		// {renewtoken} (LegacyRenewDTO lato server). CU-16/30/32.
		const body = renewToken ? { renewtoken: renewToken.token } : null;
		const result = this.callService.CallRenew<ServerAuthData>('POST', this.renewTokenUrl, body);
		return result;
	}

	logout(accessToken: Token): Observable<ServerAuthData> {
		// suppressRegen: a logout after an idle gap 401s → recovery renews to complete the logout,
		// but must NOT open a fresh analytics visit for the user who is leaving.
		const result = this.callService.CallAuth<ServerAuthData>(
			'POST',
			this.logoutUrl,
			accessToken.token,
			undefined,
			undefined,
			undefined,
			true
		);
		return result;
	}
	checkOnline(): Observable<HealthCheck> {
		return this.callService.CallHealthCheck();
	}
}
